export default "https://cdn-static.gokick.com/assets/2d58d4130188e7931b16ced23acf41c7838443e2/images/logo.fe82f4ad349e614dc769d17dbf45d7bb.svg";